import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import ItemList from 'flarum/common/utils/ItemList';
import PriceOption from './PriceOption';
export default class PaymentOptionsModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.product = this.attrs.product;
    this.for = this.attrs.for;
  }
  className() {
    return 'PaymentOptionsModal Modal--large';
  }
  title() {
    return app.translator.trans('floxum-payments.forum.payment-options-modal.title', {
      group: this.for.namePlural()
    });
  }
  options() {
    let prices = this.product?.attributes?.prices ?? [];
    const options = new ItemList();
    prices = prices instanceof Object ? Object.values(prices) : prices;
    prices.forEach(price => {
      options.add(price.id, m(PriceOption, {
        price: price,
        product: this.product,
        for: this.for
      }));
    });
    return options;
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, m("p", {
      className: "helpText"
    }, app.translator.trans('floxum-payments.forum.payment-options-modal.description')), this.options().toArray()));
  }
}
flarum.reg.add('floxum-payments', 'forum/Groups/PaymentOptionsModal', PaymentOptionsModal);